import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BotonNavegar = ({
  texto = "Acción",
  descripcion = null, // opcional, queda muy limpio en pantallas de Dashboard
  icono = null, // icono grande recomendado
  ruta = "/",
  loading = false,
  disabled = false,
  onClick = null,
  sx = {},
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled || loading) return;
    if (onClick) onClick();
    else navigate(ruta);
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: disabled || loading ? "not-allowed" : "pointer",
        userSelect: "none",

        backgroundColor: "#ffffff",
        borderRadius: 3,
        padding: 3,
        border: "1px solid rgba(0,0,0,0.1)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
        minWidth: 180,
        transition: "all 0.25s ease",

        "&:hover": {
          boxShadow:
            disabled || loading
              ? "0 2px 8px rgba(0,0,0,0.06)"
              : "0 6px 20px rgba(0,0,0,0.12)",
          transform: disabled || loading ? "none" : "translateY(-3px)",
        },

        ...sx,
      }}
    >
      {loading ? (
        <CircularProgress size={32} />
      ) : (
        <>
          {icono && (
            <Box sx={{ fontSize: "2.4rem", color: "rgba(0,0,0,0.65)" }}>
              {icono}
            </Box>
          )}

          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "rgba(0,0,0,0.8)",
              textAlign: "center",
            }}
          >
            {texto}
          </Typography>

          {descripcion && (
            <Typography
              variant="body2"
              sx={{ color: "rgba(0,0,0,0.55)", textAlign: "center" }}
            >
              {descripcion}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default BotonNavegar;
